import { __module as t } from "./ghl-ui.es1722.js";
(function(a, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var o = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(f, i, u, v) {
    return o[f];
  }, l = r;
  e.default = l, a.exports = e.default;
})(t, t.exports);
var p = t.exports;
export {
  p as f
};
